export function parseDateStr(str: string): Date | null {
  if (!str) return null
  const [y, m, d] = str.split('-').map(Number) as [number, number, number]
  return new Date(y, m - 1, d)
}

export function formatDateToStr(date: Date): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

